import { Select, Tree } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { LoaderBox } from "src/components/LoaderBox";

import * as styles from "./CatalogsTree.module.less";
import { CatalogsTreeStore } from "./CatalogsTreeStore";
import {
  CatalogTreeNode,
  findCatalogTreeNode,
  unassigned,
} from "./CatalogTreeNode";

type PropsCatalogsTree = {
  store: CatalogsTreeStore;
  onChangeNode(classifierId?: string, classId?: string): void;
};

export const CatalogsTree: React.FC<PropsCatalogsTree> = observer((props) => {
  const { store, onChangeNode } = props;
  return (
    <div className={styles.frame}>
      <div className={styles.classifiers}>
        <div className={styles.clsTitle}>Классификатор</div>
        <Select
          options={store.classifiers}
          fieldNames={{ value: "id", label: "name" }}
          placeholder={store.classifierPlaceholder}
          disabled={store.classifierDisabled}
          value={store.activeClassifierId}
          onChange={(value) => {
            store.activateClassifier(value);
            onChangeNode();
          }}
          allowClear
          title={`classifier=${store.activeClassifierId}`} // Для отладки
        />
      </div>
      <div className={styles.tree}>
        <LoaderBox
          remoteData={store.root}
          drawReady={() => (
            <InnerTree store={store} onChangeNode={onChangeNode} />
          )}
        />
      </div>
    </div>
  );
});

type PropsInnerTree = {
  store: CatalogsTreeStore;
  onChangeNode(classifierId?: string, classId?: string): void;
};

const InnerTree: React.FC<PropsInnerTree> = observer(
  ({ store, onChangeNode }) => {
    const { visualTree, selectedKey } = store;
    return (
      <Tree
        treeData={visualTree}
        loadData={(node: CatalogTreeNode) => store.loadBranch(node)}
        selectedKeys={selectedKey ? [selectedKey] : []}
        onSelect={(keys: React.Key[]) => {
          const key: string | undefined = (keys as string[])[0];
          store.setSelectedKey(key ?? null);
          let classifierId: string | undefined;
          let classId: string | undefined;
          const node = findCatalogTreeNode(visualTree, key ?? "");
          if (node && store.activeClassifierId) {
            classifierId = store.activeClassifierId;
            classId = node.id === unassigned ? undefined : node.id;
          }
          onChangeNode(classifierId, classId);
        }}
      />
    );
  },
);
